<template>
  <v-toolbar dense style="position: fixed; z-index: 5; width: 100%;">
    <v-text-field
      hide-details
      class="catalog-search-field"
      prepend-inner-icon="mdi-magnify"
      clearable
      v-model="_searchTerm"
    />
    <v-spacer></v-spacer>
    <v-btn icon @click="_showLoadedOnly = !_showLoadedOnly">
      <v-icon :color="_showLoadedOnly ? 'green' : 'inherit'">mdi-truck-check
      </v-icon>
    </v-btn>
    <v-menu
      :close-on-content-click="false"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-settings</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item  v-for="(store, i) in activeStores" :key="i">
          <v-list-item-action>
            <v-switch color="accent" v-model="store.selected"></v-switch>
          </v-list-item-action>
          <v-list-item-title>{{store.name}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn icon @click="refresh">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'

export default {
  name: 'documentsToolbar',
  computed: {
    ...mapMultiRowFields('minsk', {
      _stores: 'stores'
    }),
    ...mapFields('minsk', {
      _searchTerm: 'searchTerm',
      _showLoadedOnly: 'showLoadedOnly'
    }),
    activeStores () {
      return this._stores.filter(record => record.active)
    }
  },
  methods: {
    refresh () {
      this.$emit('onRefresh')
    }
  }
}
</script>

<style scoped>

</style>
